import React from "react";
// https://fluentsite.z22.web.core.windows.net/quick-start
import { Provider, teamsTheme } from "@fluentui/react-northstar";
import { useTeams } from "@microsoft/teamsfx-react";
import { Redirect, Route, HashRouter as Router } from "react-router-dom";
import "./App.css";
import CallForwardingSubscribe from "./CallForwardingSubscribe";
import Privacy from "./Privacy";
import Tab from "./Tab";
import TabConfig from "./TabConfig";
import Setting from "./Setting";
import TermsOfUse from "./TermsOfUse";
import Ebuero from "./Ebuero";
import AuthStart from "./AuthStart";
import AuthEnd from "./AuthEnd";
import UsersConfig from "./UsersConfig";
import SyncRouter from "./SyncRouter";
import SyncSetup from "./SyncSetup";
import SyncSettings from "./SyncSettings";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
    const { theme } = useTeams({})[0];
    return (
        <Provider
            theme={theme || teamsTheme}
            styles={{ backgroundColor: "#eeeeee" }}
        >
            <Router>
                <Route exact path="/" render={() => {
                    const hash = window.location.hash;
                    if (hash.includes('error=') || hash.includes('access_token=') || hash.includes('id_token=') || hash.startsWith('#/error=')) {
                        return <AuthEnd />;
                    }
                    return <Redirect to="/tab" />;
                }} />
                <>
                    <Route exact path="/privacy" component={Privacy} />
                    <Route exact path="/termsofuse" component={TermsOfUse} />
                    <Route exact path="/tab" component={Tab} />
                    <Route exact path="/setting" component={Setting} />
                    <Route exact path="/ebuero" component={Ebuero} />

                    <Route
                        exact
                        path="/call-forwarding-subscribe"
                        component={CallForwardingSubscribe}
                    />
                    <Route exact path="/config" component={TabConfig} />

                    {/* SSO Authentication Routes */}
                    <Route exact path="/auth-start" component={AuthStart} />
                    <Route exact path="/auth-end" component={AuthEnd} />
                    <Route exact path="/users-config" render={() => <Redirect to="/sync" />} />

                    {/* Sync Management Routes */}
                    <Route exact path="/sync" component={SyncRouter} />
                    <Route exact path="/sync/setup" component={SyncSetup} />
                    <Route exact path="/sync/dashboard" component={UsersConfig} />
                    <Route exact path="/sync/settings" component={SyncSettings} />

                    {/* Robust catch-all for MSAL redirects which often mangle the hash path */}
                    <Route path="/error" component={AuthEnd} />
                    <Route path="/access_token" component={AuthEnd} />
                    <Route path="/id_token" component={AuthEnd} />
                    <Route path="/state" component={AuthEnd} />
                </>
            </Router>
        </Provider>
    );
}
